// extracted by mini-css-extract-plugin
export default {"container":"YmGTw25XD0rUyBx0SXul","label":"NwOFGdBMRCce9_uguVQD","table-scroll":"yE285OUVWaLAeanQbrzB","recipient-viewed-text":"Kk2MCY0RsOrMWTIfWPDA"};